function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-31 -167)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  transform: "translate(31 167)",
  fill: "#25a4b4"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-271 11)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(309 163)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.428,13.171A11.553,11.553,0,0,1,0,8.241a1.064,1.064,0,0,1,.521-.964C.7,7.2,1.843,6.643,1.843,6.643A15.659,15.659,0,0,1,6.51,1.531C7.262,1.009,7.3,0,7.807,0s1.555,1.012.62,2.527A7.2,7.2,0,0,1,7.145,3.97s-1.049.8.178,1.522a3.8,3.8,0,0,0,1.761.346c.391-.022,1.338-.085,1.526-.124a1.8,1.8,0,0,1,1.324.072c.974.591.321,5.781-1.8,7.742-2.135,1.977-5.207.084-7.022.181a4.839,4.839,0,0,1-1.036-.037A1.041,1.041,0,0,1,1.428,13.171Z",
  transform: "translate(4.032)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.629,10.9c.77-.124,1.478-.244,1.628-.261.129-.014.143.159.034.21a1.012,1.012,0,0,0-.373.791,9.387,9.387,0,0,0,1.59,5.65,1.285,1.285,0,0,0,1.306.73c-.024.331-.529.516-.529.516a4.94,4.94,0,0,1-2.716.175c-1.092-.4-2.67-2.545-2.8-5.944C15.726,11.561,16.667,11.073,17.629,10.9Z",
  transform: "translate(-15.77 -3.647)",
  fill: "#fff"
}))));

var SvgReactionLike = function SvgReactionLike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReactionLike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reaction-like.4ed8e098.svg";
export { ForwardRef as ReactComponent };